/**
 * MainLayout Component - Public pages layout
 */
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '@components/layout/Header.jsx';
import Footer from '@components/layout/Footer.jsx';

const MainLayout = () => {
  return (
    <div className="main-layout">
      <Header />
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
